import { render } from "./CompetitionView.vue?vue&type=template&id=edb01d32"
import script from "./CompetitionView.vue?vue&type=script&lang=js"
export * from "./CompetitionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__